/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 1920×1080 15.6-inch laptop is about 141 PPI.`)
};

const es_ppi_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un portátil de 15,6 pulgadas a 1920×1080 tiene unos 141 PPI.`)
};

const de_ppi_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein 15,6-Zoll-Laptop mit 1920×1080 hat etwa 141 PPI.`)
};

const nl_ppi_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een laptop van 15,6 inch met 1920×1080 heeft ongeveer 141 PPI.`)
};

const fr_ppi_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un ordinateur portable de 15,6 pouces en 1920×1080 fait environ 141 PPP.`)
};

const it_ppi_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un laptop da 15,6 pollici con risoluzione 1920×1080 ha circa 141 PPI.`)
};

const pt_br2_ppi_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um notebook de 15,6 polegadas com resolução 1920×1080 tem cerca de 141 PPI.`)
};

const pt_ppi_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um portátil de 15,6 polegadas com 1920×1080 tem cerca de 141 PPI.`)
};

const ja_ppi_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1920×1080の15.6インチノートPCは約141PPIです。`)
};

const zh_ppi_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一台分辨率 1920×1080、屏幕尺寸 15.6 英寸的笔记本电脑，PPI 约为 141。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_ex1", locale)
	if (locale === "en") return en_ppi_ex1(inputs)
	if (locale === "es") return es_ppi_ex1(inputs)
	if (locale === "de") return de_ppi_ex1(inputs)
	if (locale === "nl") return nl_ppi_ex1(inputs)
	if (locale === "fr") return fr_ppi_ex1(inputs)
	if (locale === "it") return it_ppi_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_ex1(inputs)
	if (locale === "pt") return pt_ppi_ex1(inputs)
	if (locale === "ja") return ja_ppi_ex1(inputs)
	return zh_ppi_ex1(inputs)
};